<template>
    <div>
        <el-select v-model="admin_id"
                   ref="admin_selector"
                   class="w-full"
                   autocomplete="off"
                   default-first-option
                   filterable
                   clearable
                   :size="size"
                   :disabled="disabled"
                   :placeholder="placeholder"
                   @clear="fireClear"
                   @change="emitChangeEvent">
            <el-option v-for="admin in admins"
                       :key="admin.id"
                       :label="admin.name"
                       :value="admin.id">
                <span>{{ admin.name }}</span>
            </el-option>
        </el-select>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import auth from '../auth'

export default {
    props: {
        value: {
            required: false,
        },
        company_id: {
            required: false,
            type: Number
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false
        },
        title: {
            required: false,
            default: 'Account Rep'
        },
        size: {
            required: false,
            default: ''
        },
        should_confirm: {
            required: false,
            default: true
        }
    },

    data() {
        return {
            auth: auth,
            admin_id: this.value
        }
    },

    computed: {
        ...mapState({
            admins: state => state.admins
        }),

        placeholder() {
            if (this.multiple) {
                return 'Select Admin'
            }

            return 'Select Admin'
        }
    },

    methods: {
        emitChangeEvent(id) {
            // get the selected admin name
            let new_admin = ''
            if (id) {
                new_admin = this.admins.filter(admin => admin.id === id)
            }
            if (new_admin.length > 0) {
                new_admin = new_admin[0].name
            }
            // get the previous admin
            let old_admin = '';
            if (this.value) {
                old_admin = this.admins.filter(admin => admin.id === this.value)
            }
            if (old_admin.length > 0) {
                old_admin = old_admin[0].name
            }
            let message = ''
            if (new_admin.length > 0 && old_admin.length === 0) {
                message = `Are you sure you want to change the ${this.title} to ${new_admin}?`
            } else if (new_admin.length > 0 && old_admin.length > 0) {
                message = `Are you sure you want to change the ${this.title} from ${old_admin} to ${new_admin}?`
            } else {
                message = `Are you sure you want to remove the ${this.title}?`
            }

            if (this.should_confirm) {
                this.$confirm(message, 'Change Company Rep', {
                    confirmButtonText: 'Yes, I\'m sure',
                    cancelButtonText: 'No, I\'m not',
                    customClass: 'width-500 fixed',
                    type: 'warning'
                }).then(() => {
                    this.changed(id)
                }).catch((err) => {
                    if (typeof err === 'string' && err === 'cancel') {
                        this.admin_id = this.value
                    }
                })
            } else {
                this.changed(id)
            }
        },

        changed(id) {
            Vue.nextTick(() => {
                if (this.$refs.admin_selector) {
                    this.$refs.admin_selector.blur()
                }
            })
            this.$emit('change', {
                company_id: this.company_id,
                admin_id: id
            })
        },

        fireClear() {
            this.$emit('clear')
        }
    },

    watch: {
        value() {
            this.admin_id = this.value
        }
    }
}
</script>
